import React, { useEffect, useState } from "react";
import { TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import ReactDOMServer from "react-dom/server";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import axiosInstance from "../../../axiosConfig";
import MapContainer from "../../../Components/Common/MapContainer";
import { Card } from "reactstrap";

const MapComponent = (props) => {
  document.title = props.t("Plan Chauffeurs / Livreurs | Takci");

  return (
    <React.Fragment>
      <BreadCrumb title={props.t("Plan")} pageTitle="Takci" />

      {/* <div style={{ height: "calc(100vh - 120px)", width: "100%" }}>
        <MapContainer />
      </div> */}
      <Card
        style={{ width: props.width, height: "calc(100vh - 120px)" }}
        className="mt-md-3"
      >
        <MapContainer />
      </Card>
    </React.Fragment>
  );
};

MapComponent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(MapComponent));
